import React from "react";
import { useTranslation } from "react-i18next";

export default function TermsOfService() {
  const { t } = useTranslation();

  return (
    <div style={{ maxWidth: "800px", margin: "0 auto", padding: "20px", lineHeight: "1.6" }}>
      
      <h1>{t("terms.title")}</h1>

      <p><strong>{t("terms.lastUpdated")}</strong></p>

      <section>
        <h2>{t("terms.sections.intro.title")}</h2>
        <p>{t("terms.sections.intro.text")}</p>
      </section>

      <section>
        <h2>{t("terms.sections.accounts.title")}</h2>
        <p>{t("terms.sections.accounts.text")}</p>
      </section>

      <section>
        <h2>{t("terms.sections.usage.title")}</h2>
        <p>{t("terms.sections.usage.text")}</p>
      </section>

      <section>
        <h2>{t("terms.sections.liability.title")}</h2>
        <p>{t("terms.sections.liability.text")}</p>
      </section>

      <section>
       <h2>{t("terms.sections.payments.title")}</h2>
       <p>{t("terms.sections.payments.text")}</p>
      </section>

      <section>
        <h2>{t("terms.sections.changes.title")}</h2>
        <p>{t("terms.sections.changes.text")}</p>
      </section>

      <section>
        <h2>{t("terms.sections.contact.title")}</h2>
        <p>{t("terms.sections.contact.text")}</p>
      </section>

    </div>
  );
}
